<template>
    <v-container fluid class="px-0 py-0">
        <v-radio-group v-model="useSearch" row>
            <label>导出范围：</label>
            <v-radio label="按搜索条件查询结果导出" value="1"></v-radio>
            <v-radio label="导出全部" value="2"></v-radio>
        </v-radio-group>
        <v-radio-group v-model="exportTree" row>
            <label>层级结构：</label>
            <v-radio label="显示层级结构（用--标记缩进）" value="1"></v-radio>
            <v-radio label="不显示层级结构" value="2"></v-radio>
        </v-radio-group>
    </v-container>
</template>
<script>
export default {
    name: "org-export-setting",
    data() {
        return {
            useSearch: "2",
            exportTree: "1"
        };
    }
}
</script>
